export class ColorTools {

  constructor(
  ) { }

  // https://chatgpt.com/share/68adc38e-8408-8007-be79-da52a458c22d
  parseRGB(computed: string): [number, number, number] | null {
    if (typeof computed !== "string") return null;

    if (computed.startsWith("#")) {
        let hex = computed.slice(1);
        let toByte = (h: string) => parseInt(h, 16);

        if (hex.length === 3) {
            let r = toByte(hex[0] + hex[0]);
            let g = toByte(hex[1] + hex[1]);
            let b = toByte(hex[2] + hex[2]);
            return [r, g, b];
        }
        if (hex.length === 4) {
            let r = toByte(hex[0] + hex[0]);
            let g = toByte(hex[1] + hex[1]);
            let b = toByte(hex[2] + hex[2]);
            return [r, g, b];
        }
        if (hex.length === 6) {
            let r = toByte(hex.slice(0, 2));
            let g = toByte(hex.slice(2, 4));
            let b = toByte(hex.slice(4, 6));
            return [r, g, b];
        }
        if (hex.length === 8) {
            let r = toByte(hex.slice(0, 2));
            let g = toByte(hex.slice(2, 4));
            let b = toByte(hex.slice(4, 6));
            return [r, g, b];
        }
        return null;
    }

    let m = computed.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
    if (m) {
        return [parseInt(m[1], 10), parseInt(m[2], 10), parseInt(m[3], 10)];
    }

    return null;
}

getHue(color: string): {h: number, s: number} | null {
    let ctx = document.createElement("canvas").getContext("2d")!;
    ctx.fillStyle = color;
    let computed = ctx.fillStyle;
    if (typeof computed !== "string") return null;

    let rgb = this.parseRGB(computed);
    if (!rgb) return null;

    let r = rgb[0] / 255;
    let g = rgb[1] / 255;
    let b = rgb[2] / 255;

    let max = Math.max(r, g, b);
    let min = Math.min(r, g, b);
    let delta = max - min;

    // Sättigung berechnen
    let s = max === 0 ? 0 : delta / max;
    if (delta === 0) {
        return { h: 0, s: 0 }; // Graustufen
    }

    let h: number;
    if (max === r) {
        h = (60 * ((g - b) / delta) + 360) % 360;
    } else if (max === g) {
        h = 60 * ((b - r) / delta) + 120;
    } else {
        h = 60 * ((r - g) / delta) + 240;
    }

    return { h: (h + 360) % 360, s };
}

isRedOrOrange(color: string): boolean {
    let hs = this.getHue(color);
    if (!hs) return false;

    // Grau / Weiß / Schwarz → sofort false
    if (hs.s < 0.1) return false;

    let h = hs.h;
    // Rot: 345–360 oder 0–15, Orange: 16–45
    return (h >= 345 || h <= 15) || (h > 15 && h <= 45);
}

}
